module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (160).163bc8a0.jpg";